import reducer from "./reducer";
export { default as processesByPathReducerName } from "./constants";
export default reducer;
